//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const DetailsService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unit/details/loadscreenview", { id }, successCallback, failureCallback);
    }
};

export default DetailsService;